export const expireTransformBaseConfig = {
  autoExpire: true,
  expireSeconds: 1800,
};
